import _ from "lodash";
import moment from "moment";
import {parseResponse, VirtualPortfolioHandlerResource} from "../../../../../../utils/api";
import {getErrorMessage} from "../../../../../../utils/utils";
import {displayErrorSnackBar} from "../../../../../../components/SnackbarProvider/actions";
import {TRADING_ACTION_SELL, TRADING_ACTION_SWITCH} from "../../../../../../components/Charts/InstrumentsAllocationTable/constants";


export const buildTransactionDateSensitiveData = (transaction, data) => {
  const historyDate = moment(data.date, 'YYYY-MM-DD');

  let hasValue = !_.isNull(data.market_value);
  let quantity = data.quantity;
  let marketValue =  hasValue ? data.market_value : undefined;

  // In case transaction has original data and selected date is after or same as original
  // transaction date - we should "remove" this transaction from asset history,
  // so we put transaction values back to history.
  if (!!transaction.transactionOriginalData && historyDate.isSameOrAfter(transaction.transactionOriginalData.executionDate)) {
    quantity = (quantity || 0) + transaction.transactionOriginalData.executionQuantity;
    marketValue = (marketValue || 0) + transaction.transactionOriginalData.executionValue;
    hasValue = true;
  }

  let unitPrice = hasValue ? _.round(marketValue / quantity, 6) : undefined;

  return {
    price_eur: unitPrice,
    quantity: quantity,
    market_value: marketValue
  }
}


export const fetchAssetPrice = (customer_id, transaction, date, dispatch, updateTransaction, isSwitch, resource=VirtualPortfolioHandlerResource) => {
  // function to fetch asset price for transaction when date is changed

  if ([TRADING_ACTION_SELL, TRADING_ACTION_SWITCH].includes(transaction.tradingType)) {
    // get asset qty/amount/price
    resource.getInstrumentDataForDate(customer_id, transaction.data.id, date.format('YYYY-MM-DD'))
    .then((response) => {
      parseResponse(response, 'asset', (asset_data) => {
        const asset = asset_data[transaction.data.id].history[0];

        let transactionUpdateData = {
          data: {
            ...transaction.data,
            ...buildTransactionDateSensitiveData(transaction, asset)
          },
          errors: {...transaction.errors, 'asset_price': null}
        };

        updateTransaction(transaction, transactionUpdateData);
      }, (error) => {
        let transactionUpdateData = {
          data: {...transaction.data, price_eur: undefined, quantity: undefined, market_value: undefined},
        }

        updateTransaction(transaction, transactionUpdateData);
      })
    })
    .catch((error) => {
      dispatch(displayErrorSnackBar(getErrorMessage(error)))
    })
    .finally(() => {
      updateTransaction(transaction, {loading: false})
    })

    // proceed further for switch in instruments
    if (transaction.tradingType === TRADING_ACTION_SELL) return;
  }

  function setPriceToNestedTransactions(transactionUpdateData, data) {
    transactionUpdateData.buy = transaction.buy.map(
      buyTransaction => {
        const price_eur = _.get(data, `${buyTransaction.data.isin}.price_eur`);
        buyTransaction.data.price_eur = price_eur;
        if (price_eur) _.unset(buyTransaction, 'errors.asset_price');
        return buyTransaction
      }
    )
  }

  // for switch transaction there are nested buy transactions for which prices must be fetched too
  let isinsToGetPricesFor = isSwitch
    ? [transaction.data.isin, ..._.get(transaction, 'buy', []).map(buyTransaction => buyTransaction.data.isin)]
    : transaction.data.isin

  let hasBuyTransactions = isSwitch && !_.isEmpty(transaction.buy || [])

  VirtualPortfolioHandlerResource.getInstrumentPrice(isinsToGetPricesFor, date.format('YYYY-MM-DD'))
  .then((response) => {
    parseResponse(response, 'instrument_price',
      (data) => {
      let transactionUpdateData = {
        data: {...transaction.data, 'price_eur': data[transaction.data.isin].price_eur},
        errors: {...transaction.errors, 'asset_price': null}
      }

      // sets prices for nested buy transactions. If there is no price in data for an asset - undefined is set
      hasBuyTransactions && setPriceToNestedTransactions(transactionUpdateData, data)
      updateTransaction(transaction, transactionUpdateData);
      },
      (error) => {
        let transactionUpdateData = {
          data: {...transaction.data, 'price_eur': undefined},
        }

        // if there was an error - undefined is passed as there is no valid price data, so nested prices are set to undefined
        hasBuyTransactions && setPriceToNestedTransactions(transactionUpdateData, error)

        updateTransaction(transaction, transactionUpdateData);
      }
    )
  })
  .catch((error) => {
    dispatch(displayErrorSnackBar(getErrorMessage(error)))
  })
  .finally(() => {
    // as switch has nested buy transactions set their loading to false too
    if(hasBuyTransactions){
      transaction.buy = transaction.buy.map(buyTransaction => {return{...buyTransaction, loading: false}})
    }
    updateTransaction(transaction, {loading: false})
  })
}

/**
 * Toggle an item in an array by identity. Removes if found, appends if not.
 * @param {Array} list
 * @param {*} item
 * @param {Function} getId - returns comparable identity for an item
 * @returns {Array} new array
 */
export function getListWithToggledItem(list, item, getId) {
  const result = [...list];
  const id = getId(item);
  const idx = result.findIndex(a => getId(a) === id);

  if (idx !== -1) {
    result.splice(idx, 1);
  } else {
    result.push(item);
  }

  return result;
}
